import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

export default function Profile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="max-w-2xl space-y-5" data-testid="profile-page">
      <h1 className="text-3xl font-extrabold tracking-tight">Profile</h1>
      <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5">
        <div className="flex items-center gap-4">
          {user?.picture ? <img src={user.picture} alt="" className="h-16 w-16 rounded-full" /> :
            <div className="h-16 w-16 rounded-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center font-bold text-xl">{user?.name?.[0] || "U"}</div>}
          <div>
            <div className="text-lg font-semibold">{user?.name}</div>
            <div className="text-sm text-slate-500">{user?.email}</div>
            <div className="mt-1 pill bg-slate-100 dark:bg-slate-800 capitalize">{user?.role}</div>
          </div>
        </div>
        <div className="grid grid-cols-3 mt-5 gap-3 text-center">
          <div><div className="text-xs uppercase tracking-widest text-slate-500">XP</div><div className="mono font-bold text-xl">{user?.xp || 0}</div></div>
          <div><div className="text-xs uppercase tracking-widest text-slate-500">Streak</div><div className="mono font-bold text-xl">{user?.streak || 0}</div></div>
          <div><div className="text-xs uppercase tracking-widest text-slate-500">Badges</div><div className="mono font-bold text-xl">{user?.badges?.length || 0}</div></div>
        </div>
      </div>
      <Link to="/subscription" className="btn-outline">Manage subscription</Link>
      <button data-testid="profile-logout-btn" onClick={async () => { await logout(); nav("/"); }} className="btn-outline">Logout</button>
    </div>
  );
}
